import { DismantlingCoefficientTypeEnum, RatioTypeEnum } from 'gql/graphql';
import { Button, ContextMenu } from 'uikit';

import type React from 'react';
import { useCallback, useState, useMemo, useRef } from 'react';

interface IAddRatioButton {
    ratioType: RatioTypeEnum;
    onCreateCoefficientVisibilityChange: () => void;
    onSelectCoefficientVisibilityChange: () => void;
    groupType?: DismantlingCoefficientTypeEnum | null;
    isCreateDisabled?: boolean;
}

const getItemOnClick = ({ action }: any) => action;
const getItemLabel = ({ label }: any) => label;

const getItemDisabled = ({ disabled }: any) => disabled;

export const AddRatioButton: React.FC<IAddRatioButton> = (props) => {
    const {
        ratioType,
        onCreateCoefficientVisibilityChange,
        onSelectCoefficientVisibilityChange,
        groupType,
        isCreateDisabled,
    } = props;

    const ref = useRef(null);

    const [isContextOpened, setIsContextOpened] = useState(false);

    const isSelectionUnavailable = useMemo(
        () =>
            ratioType === RatioTypeEnum.ConstraintCoef ||
            (ratioType === RatioTypeEnum.DismantlingCoef &&
                groupType === DismantlingCoefficientTypeEnum.EquipmentInstallation),
        [groupType, ratioType],
    );

    const title = useMemo(
        () => (isSelectionUnavailable ? 'Создать коэффициент' : 'Добавить коэффициент'),
        [isSelectionUnavailable],
    );

    const items = useMemo(
        () => [
            {
                label: 'Создать вручную',
                action: onCreateCoefficientVisibilityChange,
                disabled: isCreateDisabled,
            },
            {
                label: 'Выбрать из прейскуранта коэффициентов',
                action: onSelectCoefficientVisibilityChange,
            },
        ],
        [isCreateDisabled, onCreateCoefficientVisibilityChange, onSelectCoefficientVisibilityChange],
    );

    const switchContextVisibility = useCallback(() => {
        setIsContextOpened(!isContextOpened);
    }, [isContextOpened]);

    const onButtonClick = useCallback(() => {
        if (isSelectionUnavailable) {
            onCreateCoefficientVisibilityChange();
        } else {
            switchContextVisibility();
        }
    }, [isSelectionUnavailable, onCreateCoefficientVisibilityChange, switchContextVisibility]);

    return (
        <>
            <Button
                label={title}
                view="secondary"
                size="s"
                onClick={onButtonClick}
                ref={ref}
                disabled={isCreateDisabled && isSelectionUnavailable}
            />
            <ContextMenu
                isOpen={isContextOpened}
                items={items}
                anchorRef={ref}
                direction="downStartLeft"
                getItemOnClick={getItemOnClick}
                getItemLabel={getItemLabel}
                getItemDisabled={getItemDisabled}
                onClickOutside={switchContextVisibility}
            />
        </>
    );
};

AddRatioButton.displayName = 'AddRatioButton';
